import React from "react";

export default function StatsInfoElement({
  containerClasses,
  iconClasses,
  textClasses,
  IconImage,
  title,
  subTitle,
  clickHandler,
}) {
  const localClickHandler = (e) => {
    if (clickHandler && typeof clickHandler === "function") {
      clickHandler(e);
    }
  };

  return (
    <div
      className={`${
        containerClasses
          ? containerClasses
          : `d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item`
      }`}
    >
      {IconImage ? (
        <div className={`${iconClasses}`}>
          <IconImage />
        </div>
      ) : (
        <i className={`${iconClasses} mr-3 icon-lg`}></i>
      )}
      <div
        className={`d-flex flex-column justify-content-around ${textClasses}`}
        onClick={localClickHandler}
      >
        <small className="mb-1">{title}</small>
        <h5 className="mr-2 mb-0">{subTitle}</h5>
      </div>
    </div>
  );
}
